(function(exports){
'use strict';

let $fallback = null;
const _t = exports.$i18n._t;

const ToMoney = (amount) => (new Intl.NumberFormat('fr-CA', {
	style: 'currency',
	currency: 'CAD',
	currencyDisplay: 'symbol',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
})).format(parseFloat(amount));

const AddProductLink = (calendar, product) => {
	const date = product.date;
	const y = date.getFullYear();
	const m = date.getMonth() + 1;
	const d = date.getDate();

	const cell = $first(`*[data-ymd='${y}-${m}-${d}']`, calendar);

	if (!$isReal(cell)) return;

	if (product.tag === 'discount') {
		// Hide discount products when quantity is below 2
		if (product.availabilities < 2) return;

		$set(cell, 'data-discounted', '1');
	}

	if (product.availabilities < 1) return;

	if (product.tag === 'regular') $set(cell, 'data-regular-price', product.price);

	const price = $mkele('span', [$mktxt(ToMoney(product.price).replace('CA', ''))], 'price');

	$set(price, 'data-calinterop', '1');
	price.classList.add(product.tag);
	$dom.add(cell, price);
	$set(cell, 'data-product', '1');

	// Disabled displaying product quantities
	// const avail = $mkele('span', [$mktxt(product.availabilities + _t('n_available_places')), $mkele('br'), $mktxt(_t('at_price'))], 'availabilities');
	// $set(avail, 'data-calinterop', '1');
	// avail.classList.add(product.tag);
	// $dom.add(cell, avail);

	$set(cell, 'data-' + product.tag + '-url', product.url);

	$e(cell, 'click', function() {
		if (window.innerWidth > 767) {
			if ($get(cell, 'data-discount-url')) { window.location.href = $get(cell, 'data-discount-url'); }
			else if ($get(cell, 'data-evening-url')) { window.location.href = $get(cell, 'data-evening-url'); }
			else if ($get(cell, 'data-regular-url')) { window.location.href = $get(cell, 'data-regular-url'); }
		}
	});

	if (!$isReal($fallback)) return;
	if (product.price < $fallback.price) {
		$dom.add(cell, $mkele('span', [$mktxt(ToMoney($fallback.price))], 'price'));
		price.classList.add('discount');
	}
};

const MaybeAddFallback = (day) => {
	if (!$isReal($fallback)) return;
	if ($first('.price', day)) return;

	const price = $mkele('span', [$mktxt(ToMoney($fallback.price))], 'price');
	$set(price, 'data-calinterop', '1');
	$dom.add(day, price);
}

const Refresh = (calendar, products, fallback) => {
	$fallback = fallback;
	$each($all('*[data-calinterop]', calendar), $dom.rm);
	$each(products, i => AddProductLink(calendar, i));
	// Disabled displaying quantities
	// $each($all("*[data-date]:not(*[data-product='1'])"), (i) => {
	// 	$dom.add(i, $mkele('span', [$mktxt('0 ' + _t('n_available_places'))], 'availabilities'));
	// });
	$each($all('*[data-date]:not(.past):not(.next-month)', calendar), MaybeAddFallback);
};

exports.CalendarProducts = {
	Refresh,
	AddProductLink,
};

}(window));
